
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Response} from '../core/Response';
import {FieldModelResponse} from '../core/Response';

/**
 * FeedSubscriptionGetResponse struct
 */
class FeedSubscriptionGetResponse extends Response {
  /**
   * Initialize struct
   * @param {!Response=} parent
   * @param {!Map=} symbolIdsWithLevels
   * @constructor
   */
  constructor (parent = new Response(), symbolIdsWithLevels = new Map()) {
    super()
    super.copy(parent)
    this.SymbolIdsWithLevels = symbolIdsWithLevels
  }

  /**
   * Copy struct (shallow copy)
   * @this {!FeedSubscriptionGetResponse}
   * @param {!FeedSubscriptionGetResponse} other Other struct
   * @returns {!FeedSubscriptionGetResponse} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.SymbolIdsWithLevels != null) {
      this.SymbolIdsWithLevels = new Map()
      Object.keys(other.SymbolIdsWithLevels).forEach(key => {
        if (key != null) {
          let tempKey
          tempKey = new UUID(key)
          if (other.SymbolIdsWithLevels[key] != null) {
            let tempValue
            tempValue = other.SymbolIdsWithLevels[key]
            this.SymbolIdsWithLevels.set(tempKey, tempValue)
          } else {
            this.SymbolIdsWithLevels.set(tempKey, null)
          }
        }
      })
    } else {
      this.SymbolIdsWithLevels = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!FeedSubscriptionGetResponse}
   * @returns {!FeedSubscriptionGetResponse} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new FeedSubscriptionGetResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new FeedSubscriptionGetResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!FeedSubscriptionGetResponse}
   * @param {!FeedSubscriptionGetResponse} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof FeedSubscriptionGetResponse)) {
      throw new TypeError('Instance of FeedSubscriptionGetResponse is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!FeedSubscriptionGetResponse}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      SymbolIdsWithLevels: ((this.SymbolIdsWithLevels != null) ? fbe.MapToObject(new Map(Array.from(this.SymbolIdsWithLevels, item => [((item[0] != null) ? item[0].toString() : null), ((item[1] != null) ? item[1] : null)]))) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return FeedSubscriptionGetResponse.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!FeedSubscriptionGetResponse} other Object value
   * @returns {!FeedSubscriptionGetResponse} Created struct
   */
  static fromObject (other) {
    return new FeedSubscriptionGetResponse().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!FeedSubscriptionGetResponse}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return FeedSubscriptionGetResponse.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!FeedSubscriptionGetResponse}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 2037
  }
}

export { FeedSubscriptionGetResponse };

/**
 * Fast Binary Encoding FeedSubscriptionGetResponse field model
 */
class FieldModelFeedSubscriptionGetResponse extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelResponse(buffer, 4 + 4)
    this.SymbolIdsWithLevels = new fbe.FieldModelMap(new fbe.FieldModelUUID(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), new fbe.FieldModelUInt16(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
  }

  /**
   * Get the core.Response field model
   * @this {!FieldModelFeedSubscriptionGetResponse}
   * @returns {!FieldModelResponse} core.Response field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelFeedSubscriptionGetResponse}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelFeedSubscriptionGetResponse}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.SymbolIdsWithLevels.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelFeedSubscriptionGetResponse}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.SymbolIdsWithLevels.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelFeedSubscriptionGetResponse}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelFeedSubscriptionGetResponse.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelFeedSubscriptionGetResponse}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 2037
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelFeedSubscriptionGetResponse}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelFeedSubscriptionGetResponse}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.SymbolIdsWithLevels.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SymbolIdsWithLevels.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolIdsWithLevels.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelFeedSubscriptionGetResponse}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelFeedSubscriptionGetResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelFeedSubscriptionGetResponse}
   * @param {!FeedSubscriptionGetResponse} fbeValue Default value, defaults is new FeedSubscriptionGetResponse()
   * @returns {!FeedSubscriptionGetResponse} FeedSubscriptionGetResponse value
   */
  get (fbeValue = new FeedSubscriptionGetResponse()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelFeedSubscriptionGetResponse}
   * @param {!FeedSubscriptionGetResponse} fbeValue FeedSubscriptionGetResponse value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.SymbolIdsWithLevels.fbeSize) <= fbeStructSize) {
      this.SymbolIdsWithLevels.get(fbeValue.SymbolIdsWithLevels)
    } else {
      fbeValue.SymbolIdsWithLevels.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolIdsWithLevels.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelFeedSubscriptionGetResponse}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelFeedSubscriptionGetResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelFeedSubscriptionGetResponse}
   * @param {!FeedSubscriptionGetResponse} fbeValue FeedSubscriptionGetResponse value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelFeedSubscriptionGetResponse}
   * @param {FeedSubscriptionGetResponse} fbeValue FeedSubscriptionGetResponse value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.SymbolIdsWithLevels.set(fbeValue.SymbolIdsWithLevels)
  }
}

export { FieldModelFeedSubscriptionGetResponse };

/**
 * Fast Binary Encoding FeedSubscriptionGetResponse model
 */
class FeedSubscriptionGetResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelFeedSubscriptionGetResponse(this.buffer, 4)
  }

  /**
   * Get the FeedSubscriptionGetResponse model
   * @this {!FeedSubscriptionGetResponseModel}
   * @returns {!FieldModelFeedSubscriptionGetResponse} model FeedSubscriptionGetResponse model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!FeedSubscriptionGetResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!FeedSubscriptionGetResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return FeedSubscriptionGetResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!FeedSubscriptionGetResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelFeedSubscriptionGetResponse.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!FeedSubscriptionGetResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!FeedSubscriptionGetResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!FeedSubscriptionGetResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!FeedSubscriptionGetResponseModel}
   * @param {!FeedSubscriptionGetResponse} value FeedSubscriptionGetResponse value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!FeedSubscriptionGetResponseModel}
   * @param {!FeedSubscriptionGetResponse} value FeedSubscriptionGetResponse value, defaults is new FeedSubscriptionGetResponse()
   * @return {!object} Deserialized FeedSubscriptionGetResponse value and its size
   */
  deserialize (value = new FeedSubscriptionGetResponse()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new FeedSubscriptionGetResponse(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new FeedSubscriptionGetResponse(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!FeedSubscriptionGetResponseModel}
   * @param {!number} prev Previous FeedSubscriptionGetResponse model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { FeedSubscriptionGetResponseModel };
